// extracted by mini-css-extract-plugin
module.exports = {"hero":"HelpHero_hero__1mAaN","heading":"HelpHero_heading__K9QV6"};